import axios from 'axios';
import { N8N_URL } from '../config';

export const sendMessage = async (cpf) => {
  try {
    const response = await axios.post(
      N8N_URL,
      { cpf },
      { timeout: 180000 } // Define um tempo limite de 10 segundos
    );
    console.log('RESPOSTA n8n:', response.data); // Para debug

    // Corrigido para acessar o primeiro item do array
    const reply = response.data[0]?.html || 'Não consegui achar... Lembre-se que são compras dos últimos 2 meses!';
    return reply;
  } catch (err) {
    if (err.code === 'ECONNABORTED') {
      console.error('Erro: Tempo limite excedido ao chamar o n8n.');
      throw new Error('Tempo limite excedido. Tente novamente mais tarde.');
    }
    console.error('Erro ao chamar o n8n:', err);
    throw err;
  }
};